var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v(" Michał Gruszczyński, Director of Photography, gruszczynskimichal@gmail.com +48 603 810 040 © All rights reserved "+_vm._s(new Date().getFullYear())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }